import { render } from "./TreatmentPlanDetail.vue?vue&type=template&id=17e644ee&scoped=true"
import script from "./TreatmentPlanDetail.vue?vue&type=script&lang=js"
export * from "./TreatmentPlanDetail.vue?vue&type=script&lang=js"

import "./TreatmentPlanDetail.vue?vue&type=style&index=0&id=17e644ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e644ee"]])

export default __exports__